// GA4 Event Names
export enum GAEvents {
    // Auth Events
    LOGIN_CLICK = 'login_click',
    LOGIN_SUCCESS = 'login_success',
    LOGIN_FAILED = 'login_failed',
    LOGOUT = 'logout',

    // Navigation Events
    PAGE_VIEW = 'page_view',
    FROM_LANDING_TO_CODES = 'from_landing_to_codes',

    // User Actions
    BUTTON_CLICK = 'button_click',
    FORM_SUBMIT = 'form_submit',

    // Workspace Events
    WORKSPACE_CREATE = 'workspace_create',
    WORKSPACE_DELETE = 'workspace_delete',
    WORKSPACE_SWITCH = 'workspace_switch',

    // Project Events
    PROJECT_CREATE = 'project_create',
    PROJECT_DELETE = 'project_delete',
    PROJECT_SWITCH = 'project_switch',

    // Service Events
    SERVICE_CREATE = 'service_create',
    SERVICE_DELETE = 'service_delete',
    SERVICE_DEPLOY = 'service_deploy',
    SERVICE_REDEPLOY = 'service_redeploy',
}

// Event Parameters Interface
export interface GAEventParams {
    method?: string;
    provider?: string;
    workspace_id?: string;
    project_id?: string;
    service_id?: string;
    button_name?: string;
    form_name?: string;
    error_message?: string;
    debug_mode?: boolean;
    [key: string]: string | number | boolean | undefined;
}
